var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation container"},[_c('b-nav',{staticClass:"float-right"},[_c('b-nav-item',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/projects"}},[_vm._v("Projects")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/articles"}},[_vm._v("Articles")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"ident":"vue-loader-options"}!./node_modules/vue-loader/lib?{"ident":"vue-loader-options"}!./src/Components/Navigation.vue?vue&type=template&id=2238897c
// module id = 189
// module chunks = 0